import { environment } from '../../../environments/environment';
import { FooterModel } from './footer.model';

export const footerItemsConst: Array<FooterModel> = [
    {
        text:
            'CloudFlow Evidence v' +
            environment.version +
            (environment['type'] ? '-' + environment['type'] : '') +
            ' | (C) Copyright GITS 2023',
        path: 'http://www.gitscom.ro'
    }
];
